<template>
  <div class="container-fluid">
    <loading class="register-overlay" v-show="showLoader" />

    <div class="row">
      <div class="col-md-10 offset-md-1 px-5">
        <div class="jbl-otp-h-right jbl-otp-right">
          <div class="text-center d-block my-5">
              <img alt="Logo Icon" class="img-fluid in-fluid-70" :src="require('@/assets/images/ib-logo.svg')" />
          </div>
          <div class="text-center d-block my-5">
              <img alt="Logo Icon" class="img-fluid fa-spin" :src="require('@/assets/images/in-loading-wait.svg')" />
          </div>
          <div class="jbl-otp-heading">
            <h5 class="ib-auth-desc" style="">We have sent you a link to verify your Email at <span class="email-block">{{ currentUser.email }}</span></h5>
          </div>
          <Timer class="ib-timer" :value="time" @timeout="timeOut()" v-if="showTimer"></Timer>
          <!-- <hr class="ib-dotted-hr" style="width:100% !important;"> -->
          <div class="jbl-mx-auto" style="margin: 0 auto; text-align: center; display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <!-- <a @click="updateEmail()" class="ib-link mt-4 pt-3" style="float:right;">Update Email</a> -->
            <button @click="verifyEmail('btn')" class="ib-btn-primary ib-btn-width ib-btn-hover" style="width: 100% !important;">Verify</button>
            <div v-if="showResend">
              <div style="color:var(--text-color); font-family:'Avenir Book'">OR</div>
              <a @click="resendEmail()" class="ib-link" style="float:right;">Resend Email</a>
            </div>
          </div>
          <div class="ib-action-btns">
            <button @click="cancel()" class="ib-btn-outline ib-btn-width ib-btn-hover mr-3">Cancel</button>
            <button @click="updateEmail()" class="ib-btn-outline ib-btn-width ib-btn-hover">Update Email</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showUpdateEmailModal">
      <transition name="modal fade">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
              <div class="modal-content">
                <div class="jbl-m-inner">
                  <div class="modal-header pb-0">
                    <h3 class="login-m-title">Update Email</h3>
                    <span class="ib-m-close" @click="closeEmailModal()"></span>
                  </div>
                  <div class="modal-body">
                    <div>
                      <div class="jbl-field-sign">
                        <label class="jbl-label-sign">Email</label>
                        <input type="email" class="ib-login-input" v-model="newEmail" placeholder="Enter Email"/>
                      </div>

                      <div v-if="errors.filter(x => x.field == 'newEmail').length > 0">
                        <div class="d-block jbl-text-danger">
                          <small class="text-danger in-bottom-0">{{errors.filter(x => x.field == 'newEmail')[0].message}}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer ib-m-footer">
                    <button class="ib-btn-primary ib-btn-hover mr-2" style="padding: 0.7125rem 1.5625rem !important; position: relative !important; top: 2px !important;" type="button" @click="updateEmailPost()">Update</button>
                    <button type="button" class="ib-btn-outline ib-btn-hover" @click="closeEmailModal()">Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import { mask } from "vue-the-mask";
  import loading from '@/components/Loading/Loading';
  import Timer from '@/components/Countdown/Timer';
  import axios from "axios";
  import { mapActions, mapState } from "vuex";

  export default {
    name: 'OtpVerification',
    directives: { mask },
    components: {
      loading,
      Timer
    },
    data () {
      return {
        showLoader: false,
        showTimer: true,
        showResend: false,
        currentUser : this.$store.getters.getUser,
        showUpdateEmailModal: false,
        newEmail: '',
        errors: [],
        time: 300
      }
    },
    created () {
      const self = this;
      if(self.$store.getters.isAuthenticated && self.$store.getters.isEmailVerified) {
        self.$router.push({ name: 'Home' });
      }
      if(!self.$store.getters.isAuthenticated) {
        self.$store.commit("resetState");
        window.location.reload();
      }

      document.addEventListener('visibilitychange', function(ev) {
        if(!self.$store.getters.isEmailVerified && document.visibilityState == 'visible') {
          self.verifyEmail('tab');
        }
      });

      this.unwatch = this.$store.watch(
        (state, getters) => getters.isEmailVerified,
        (newValue, oldValue) => {
          let user = self.$store.getters.getUser;
          $toast.success('Email Verified Successfully!!', { position: 'top-right' });
          self.$root.$emit('closeVerifyEmailModal');
          if(user.chance_become_founder_member && user.is_founder_member == 0) {
            self.$root.$emit('showPromoModal');
          }
        },
      );
    },
    computed: {
      ...mapState(['user']),
    },
    beforeDestroy() {
      this.unwatch();
    },
    methods: {
      timeOut () {
        const self = this;
        self.showResend = true;
        self.showTimer = false;
      },
      async resendEmail () {
        const self = this;

        self.showLoader = true;
        await axios.get('customer/email/resend').then(function (response) {
          self.showLoader = false;
          self.showResend = false;
          self.showTimer = true;
          if (response.data.code == 200) {
            self.newEmail = '';
            $toast.success('Verification Link Has Been Re-sent To Your Email', { position: 'top-right' });
          } else {
            $toast.error(response.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.response) {
            error.response.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      updateEmail () {
        const self = this;
        self.errors = [];
        self.newEmail = '';
        self.showUpdateEmailModal = true;
      },
      async updateEmailPost () {
        const self = this;
        self.errors = [];

        let email = self.newEmail;

        if(email == '') {
          $toast.error('Please Enter Email', { position: 'top-right' });
          return false;
        }
        if(self.newEmail == self.currentUser.email){
          $toast.error( 'Please Enter different Email', { position: 'top-right' });
          return false;
        }

        const re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let result = re.test(String(email).toLowerCase());
        if(!result) {
          self.errors.push({
            field: 'newEmail',
            message: 'Invalid Email'
          });
        }

        if (self.errors.length > 0) {
          return false;
        }

        var formData = new FormData();
        formData.append('email', email);

        self.showTimer = false;
        self.showLoader = true;
        self.showUpdateEmailModal = false;
        await axios.post('customer/change_mobile_no', formData).then(function (response) {
          self.showLoader = false;
          self.showTimer = true;
          if (response.data.code == 200) {
            self.currentUser.email = email;
            self.$store.commit('updateUserEmail', email);
            self.closeEmailModal();
            self.showResend = false;
            $toast.success('Email Updated Successfully!!', { position: 'top-right' });
          } else {
            $toast.error(response.data.message, { position: 'top-right' });
            self.showUpdateEmailModal = true;
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          self.showUpdateEmailModal = true;
          if(error.response) {
            error.response.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      verifyEmail (source) {
        const self = this;

        axios.get('customer/user').then((response) => {
          if(response.data.code == 200) {
            const user = response.data.data;
            self.$store.commit('setUser', user);
            $toast.success('Email Verified Successfully!!', { position: 'top-right' });
            self.$root.$emit('closeVerifyEmailModal');
            if(user.chance_become_founder_member && user.is_founder_member == 0) {
              self.$root.$emit('showPromoModal');
            }
          } else {
            if(source == 'btn') {
              $toast.error(response.data.message, { position: 'top-right' });
            }
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.response) {
            error.response.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      closeEmailModal () {
        const self = this;
        self.errors = [];
        self.newEmail = '';
        self.showUpdateEmailModal = false;
      },
      cancel() {
        const self = this;
        self.$root.$emit('logoutUser');
      }
    }
  }
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
  /*

  .container-fluid {
    background-repeat: no-repeat;
    height: 100%;
    position: fixed;
  }

  .jbl-sign-left h1 {
    font-size: 49px !important;
  }

  @media (max-width:850px) and (min-width: 750px) {
    .jbl-field.jbl-otp-field {
      margin-left: auto;
    }
  }

  @media (max-width:450px) {
    .jbl-otp-field {
      min-width: 300px !important;
    }

    .jbl-otp-right h5 {
      font-family: "Futura PT Medium";
      font-size: 25px;
      font-weight: 500;
      line-height: 1.28;
      color: #5b6770;
    }
  }

  @media (min-width:451px) {
    .jbl-otp-field {
      min-width: 380px !important;
    }
  }

  .modal-dialog-scrollable .modal-body {
    overflow-y: auto;
    overflow-x: hidden !important;
  }
  .jbl-otp-heading{
    max-width: 380px;
  }
  @media (max-width:1200px){
    .jbl-otp-heading{
      text-align: center !important;
      padding: .1rem;
    }
  }
  .jbl-otp-right h5 {
    font-family: "Futura PT Medium";
    font-size: 25px !important;
    font-weight: 500;
    line-height: 1.28;
    color: #5b6770;
  }
  @media(max-width:550px){
    .jbl-otp-right h5{
      font-size: 15px !important;
    }
    .in-fluid-70{
      max-width: 70% !important;
    }
  }
  @media(max-width:1200px){
    .ib-btn-width {
      max-width: 80px !important;
    }
    .ib-btn-primary {
      padding: 6px 9px !important;
    }
  }
  div small.text-danger.in-bottom-0{
    position: relative;
    bottom: 0rem !important;
  } */
  .ib-auth-desc {
    font-family: "Avenir Book" !important;
    color: var(--sub-heading-color) !important;
    font-size: 20px;
    text-align: center;
}
.ib-timer{
  text-align: center;
}
.ib-link {
    font-weight: 500 !important;
    text-decoration: underline !important;
}
@media(min-width:600px){
.otp-branding{
    max-width: 350px;
  }
}
.email-block{
    background: #F2F2F2;
    border-radius: 30px;
    padding: 5px 30px;
    display: block;
    max-width: max-content;
    margin: 13px auto;
    text-align: center;
    color: #AFAFAF;
    display: flex;
    justify-content: center;
}
.ib-action-btns{
    display: flex;
    justify-content: space-between;
}
.jbl-otp-h-right.jbl-otp-right{
    max-width: 350px;
    margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/VerifyEmailAcquisition.vue